import React, {createContext, useState, use} from "react";
import PropTypes from "prop-types";
import {NetworkErrorPage} from "../NetworkErrorPage";

export const NetworkErrorContext = createContext();

export const NetworkErrorProvider = ({children}) => {
  const [networkError, setNetworkError] = useState();

  return (
    <NetworkErrorContext
      value={{
        networkError,
        setNetworkError,
      }}
    >
      {networkError ? NetworkErrorPage : children}
    </NetworkErrorContext>
  );
};

NetworkErrorProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useNetworkError = () => {
  return use(NetworkErrorContext);
};
